/* Read catalog choices from the existing category sections, on first interaction. */
(function () {
  var paths = { sla: 'lcd-catalog-download', fdm: 'fff-catalog-download', scanner: '3dscanner-catalogscanner', business: 'for-business-use-catalog-download' };
  function normalized(value) { return String(value || '').normalize('NFKC').toLowerCase().replace(/[\s・\-_]/g, ''); }
  function init(root) {
    var box = root.querySelector('[data-sk-cs]');
    if (!box || box.getAttribute('data-initialized') === '1' || !window.fetch) return;
    var field = box.querySelector('[data-sk-cs-search]');
    var results = box.querySelector('[data-sk-cs-results]');
    var status = box.querySelector('[data-sk-cs-status]');
    var error = box.querySelector('[data-sk-cs-error]');
    var confirm = box.querySelector('[data-sk-cs-confirm]');
    var all = box.querySelector('[data-sk-cs-all]');
    var manual = box.querySelector('[data-sk-cs-manual]');
    var clear = box.querySelector('[data-sk-cs-clear]');
    var scrollHint = box.querySelector('[data-sk-cs-scroll-hint]');
    var filters = box.querySelector('[data-sk-cs-filters]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('.sk-cr__chip[data-category]'));
    var categories = [], cache = {}, active = '', started = false, pending = null, returnFocus = null;
    var selected = new URLSearchParams(window.location.search).get('model') || '';
    var renderedKey = '';
    var motion = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; };
    var text = function (name) { return box.getAttribute('data-' + name + '-text') || ''; };
    chips.forEach(function (chip) {
      var key = chip.getAttribute('data-category');
      if (!Object.prototype.hasOwnProperty.call(paths, key) || categories.some(function (c) { return c.key === key; })) return;
      try {
        var url = new URL(chip.getAttribute('href'), window.location.href);
        if (url.origin !== window.location.origin || !url.pathname.endsWith('/pages/' + paths[key])) return;
        url.search = ''; url.hash = '';
        var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        categories.push({ key: key, label: chip.getAttribute('data-label') || key, url: url.href, chip: chip });
      } catch (e) {}
    });
    if (!categories.length || !field || !results || !confirm) return;

    function readData(html, key) {
      // Parse only the data island: DOMParser can request resources in fetched HTML.
      if (html.length > 4000000) throw new Error('catalog response too large');
      var match = /<script\b(?=[^>]*\stype\s*=\s*["']application\/json["'])(?=[^>]*\sdata-sk-catalog-selector-data(?=[\s=>]))[^>]*>([\s\S]*?)<\/script\s*>/i.exec(html);
      var data = match && JSON.parse(match[1]);
      if (!data || data.version !== 2 || data.category !== key || !Array.isArray(data.items) || data.items.length > 100) throw new Error('catalog data unavailable');
      data.items.forEach(function (item) {
        if (!item || typeof item.model !== 'string' || !item.model.trim() || item.model.length > 200 || typeof item.maker !== 'string' || item.maker.length > 200 || typeof item.image !== 'string' || typeof item.requestable !== 'boolean' || typeof item.discontinued !== 'boolean') throw new Error('catalog data invalid');
      });
      return data.items;
    }
    function load(category) {
      if (cache[category.key]) return cache[category.key].promise;
      var entry = { state: 'loading', items: [] }, controller = new AbortController();
      cache[category.key] = entry;
      var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
      entry.promise = window.fetch(category.url, { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok || (response.url && new URL(response.url).origin !== window.location.origin)) throw new Error('catalog request failed');
          return response.text();
        }).then(function (html) { entry.items = readData(html, category.key); entry.state = 'ready'; })
        .catch(function () { entry.state = 'error'; })
        .finally(function () { window.clearTimeout(timeout); if (root.isConnected) render(); });
      return entry.promise;
    }
    function visibleCategories() { return categories.filter(function (category) { return !active || active === category.key; }); }
    function start() {
      started = true;
      visibleCategories().forEach(load);
      render();
    }
    function element(tag, className, value) {
      var node = document.createElement(tag); node.className = className || '';
      if (value !== undefined) node.textContent = value;
      return node;
    }
    function imageFor(item) {
      var holder = element('span', 'sk-cs__image');
      // Fixed decoration, never fetched HTML.
      holder.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M6 3h8l4 4v14H6zM14 3v5h4M9 12h6M9 16h6"/></svg>';
      try {
        var url = new URL(item.image, window.location.href);
        if (!item.image || url.protocol !== 'https:' || (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com')) return holder;
        var img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 62;
        img.addEventListener('error', function () { img.remove(); holder.firstChild.removeAttribute('hidden'); });
        img.addEventListener('load', function () { holder.firstChild.setAttribute('hidden', ''); });
        img.src = url.href; holder.appendChild(img);
      } catch (e) {}
      return holder;
    }
    function choose(item, trigger) {
      var iframe = root.querySelector('[data-sk-cr-iframe]');
      if (iframe && iframe.getAttribute('src') && item.model !== selected) {
        pending = item; returnFocus = trigger;
        box.querySelector('[data-sk-cs-confirm-model]').textContent = item.model || manual.textContent;
        confirm.removeAttribute('hidden');
        confirm.scrollIntoView({ behavior: motion(), block: 'nearest' }); confirm.focus({ preventScroll: true });
        return;
      }
      applyChoice(item);
    }
    function applyChoice(item) {
      confirm.setAttribute('hidden', ''); pending = null; selected = item.model;
      root.dispatchEvent(new CustomEvent('sk:catalog-select', { detail: { model: item.model, category: item.category || '', source: 'catalog-selector', confirmed: true } }));
      if (started) render();
    }
    function render() {
      if (!started) return;
      var key = active + '\n' + field.value;
      var oldTop = key === renderedKey ? results.scrollTop : 0;
      var focused = results.contains(document.activeElement) ? document.activeElement.skCatalogKey : '';
      renderedKey = key;
      var current = visibleCategories(), rows = [], failures = [], loading = false;
      current.forEach(function (category) {
        var entry = cache[category.key];
        if (!entry || entry.state === 'loading') { loading = true; return; }
        if (entry.state === 'error') { failures.push(category); return; }
        entry.items.forEach(function (item) {
          var existing = rows.find(function (row) { return row.model === item.model && row.maker === item.maker; });
          if (existing) {
            if (item.requestable && !item.discontinued && !existing.requestable) { existing.requestable = true; existing.category = category.key; }
            return;
          }
          rows.push({ model: item.model, maker: item.maker, image: item.image, requestable: item.requestable && !item.discontinued, category: category.key });
        });
      });
      var words = String(field.value || '').normalize('NFKC').trim().split(/\s+/).map(normalized).filter(Boolean);
      rows = rows.filter(function (item) { var candidate = normalized(item.model + ' ' + item.maker); return words.every(function (word) { return candidate.indexOf(word) !== -1; }); });
      results.replaceChildren(); results.setAttribute('aria-busy', String(loading));
      rows.forEach(function (item) {
        var isSelected = item.model === selected;
        var row = element(item.requestable ? 'button' : 'div', 'sk-cs__row' + (item.requestable ? '' : ' is-unavailable'));
        row.skCatalogKey = JSON.stringify([item.model, item.maker]);
        row.appendChild(imageFor(item));
        var body = element('span', 'sk-cs__body');
        body.appendChild(element('span', 'sk-cs__maker', item.maker));
        body.appendChild(element('span', 'sk-cs__model', item.model));
        var ready = item.requestable && typeof root.skCatalogDelivery === 'function' && root.skCatalogDelivery(item.model);
        body.appendChild(element('span', 'sk-cs__delivery' + (ready ? ' is-ready' : ''), text(!item.requestable ? 'unavailable' : ready ? 'ready' : 'followup')));
        row.appendChild(body);
        if (item.requestable) {
          row.type = 'button'; row.setAttribute('aria-pressed', String(isSelected));
          row.appendChild(element('span', 'sk-cs__action', text(isSelected ? 'selected' : 'select')));
          row.addEventListener('click', function () { choose(item, row); });
        }
        results.appendChild(row);
        if (focused && row.skCatalogKey === focused && item.requestable) row.focus({ preventScroll: true });
      });
      results.scrollTop = oldTop;
      if (clear) clear.hidden = !active && !field.value;
      updateScrollHint();
      status.textContent = loading ? text('loading') : failures.length ? text('error-status') || text('error') : rows.length ? text('count').replace('{count}', rows.length) : text('empty');
      error.hidden = !failures.length;
      if (failures.length) {
        box.querySelector('[data-sk-cs-error-text]').textContent = text('error');
        var fallback = box.querySelector('[data-sk-cs-fallback]'); fallback.replaceChildren();
        failures.forEach(function (category) { var link = element('a', '', category.label); link.href = category.url; fallback.appendChild(link); });
      }
    }
    function filter(key) {
      pending = null; confirm.setAttribute('hidden', '');
      active = key;
      categories.forEach(function (category) { category.chip.setAttribute('aria-pressed', String(active === category.key)); });
      all.setAttribute('aria-pressed', String(!active)); start();
    }
    categories.forEach(function (category) {
      category.chip.setAttribute('role', 'button'); category.chip.setAttribute('aria-pressed', 'false');
      category.chip.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); filter(category.key);
      });
      category.chip.addEventListener('keydown', function (event) { if (event.key === ' ') { event.preventDefault(); filter(category.key); } });
    });
    all.addEventListener('click', function () { filter(''); });
    field.addEventListener('focus', start);
    field.addEventListener('input', function () { pending = null; confirm.setAttribute('hidden', ''); start(); });
    if (clear) clear.addEventListener('click', function () { field.value = ''; filter(''); field.focus({ preventScroll: true }); });
    manual.addEventListener('click', function () { choose({ model: '', category: active }, manual); });
    box.querySelector('[data-sk-cs-retry]').addEventListener('click', function () {
      visibleCategories().forEach(function (category) { if (cache[category.key] && cache[category.key].state === 'error') delete cache[category.key]; }); start();
    });
    box.querySelector('[data-sk-cs-confirm-yes]').addEventListener('click', function () { if (pending) applyChoice(pending); });
    function cancel() { pending = null; confirm.setAttribute('hidden', ''); if (returnFocus && returnFocus.isConnected) returnFocus.focus(); else field.focus(); }
    box.querySelector('[data-sk-cs-confirm-no]').addEventListener('click', cancel);
    confirm.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); cancel(); } });
    root.addEventListener('sk:catalog-open', function () { box.scrollIntoView({ behavior: motion(), block: 'start' }); field.focus({ preventScroll: true }); });
    var promptOpen = root.querySelector('[data-sk-cr-prompt-open]');
    if (promptOpen) promptOpen.addEventListener('click', function () { root.dispatchEvent(new CustomEvent('sk:catalog-open')); });
    var chipNav = root.querySelector('.sk-cr__chips');
    if (filters && chipNav) filters.appendChild(chipNav);
    function updateScrollHint() { if (scrollHint) scrollHint.hidden = results.scrollHeight <= results.clientHeight + 1; }
    if (window.ResizeObserver && scrollHint) {
      var observer = new window.ResizeObserver(function () { if (root.isConnected) updateScrollHint(); else observer.disconnect(); });
      observer.observe(results);
    }
    box.setAttribute('data-initialized', '1'); box.removeAttribute('hidden'); root.classList.add('has-selector');
    var prompt = root.querySelector('[data-sk-cr-choose-prompt]');
    if (prompt && !selected) prompt.removeAttribute('hidden');
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sk-cr]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
